import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import toastr from "toastr";
import Button from "@material-ui/core/Button";
import {
  NotificationContainer,
  NotificationManager
} from "react-notifications";
import IntlMessages from "util/IntlMessages";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
  hideMessage,
  showAuthLoader,
  userFacebookSignIn,
  userGithubSignIn,
  userGoogleSignIn,
  userSignIn,
  userTwitterSignIn,
  changeStatus
} from "actions/Auth";

class SignIn extends React.Component {
  constructor() {
    super();
    this.state = {
      email: "superadmin@gmail.com",
      password: "adminadmin",
      loader: false
    };
  }

  componentDidUpdate() {
    if (this.props.showMessage) {
      setTimeout(() => {
        this.props.hideMessage();
      }, 100);
    }
  }

  componentWillReceiveProps(nextProps) {
    console.log("=========nextProps===========================");
    console.log(nextProps.userStatus);
    console.log("====================================");
    this.setState({
      loader: false
    });
    if (nextProps.userStatus && nextProps.isLoading == "move") {
      this.props.history.push("/admin/dashboard/customers");
    }
  }

  validateEmail = email => {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-z  A-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };
  logIn = () => {
    console.log("=============this.state.password <= 7=======================");
    console.log(this.state.password.length);
    console.log("====================================");
    if (this.state.email == "" || !this.validateEmail(this.state.email)) {
      toastr.error("Invalid email address!");
    } else if (this.state.password.length <= 7) {
      toastr.error("Password must have eight or more characters!");
    } else {
      let obj = {
        email: this.state.email,
        password: this.state.password
      };

      this.props.userSignIn(obj);
      this.setState({
        loader: true
      });
    }
  };

  render() {
    const { email, password } = this.state;
    const { showMessage, alertMessage } = this.props;
    const { loader } = this.state;

    return (
      <div className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
        <div className="app-login-main-content">
          <div className="app-logo-content d-flex align-items-center justify-content-center">
            <Link className="logo-lg" to="/" title="Jambo">
              <img
                width="100%"
                src={require("assets/unhr-images/Logo-Extra.png")}
                alt="jambo"
                title="jambo"
              />
            </Link>
          </div>

          <div className="app-login-content">
            <div className="app-login-header mb-4">
              <h1>Unhr Super Admin Panel</h1>
            </div>

            <div className="app-login-form">
              <form>
                <fieldset>
                  <TextField
                    label={<IntlMessages id="appModule.email" />}
                    fullWidth
                    onChange={event =>
                      this.setState({ email: event.target.value })
                    }
                    defaultValue={email}
                    margin="normal"
                    className="mt-1 my-sm-3"
                  />
                  <TextField
                    type="password"
                    label={<IntlMessages id="appModule.password" />}
                    fullWidth
                    onChange={event =>
                      this.setState({ password: event.target.value })
                    }
                    defaultValue={password}
                    margin="normal"
                    className="mt-1 my-sm-3"
                  />

                  <div className="mb-3 d-flex align-items-center justify-content-between">
                    <Button
                      onClick={this.logIn}
                      variant="contained"
                      color="primary"
                    >
                      <IntlMessages id="appModule.signIn" />
                    </Button>
                  </div>
                  <div onClick={this.props.changeStatus} style={{cursor: "pointer"}}>Login As A Reviewer</div>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
        {loader && (
          <div className="loader-view">
            <CircularProgress />
          </div>
        )}
        {showMessage && NotificationManager.error(alertMessage)}
        <NotificationContainer />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    hasErrored: state.auth.hasErrored,
    loader: state.auth.loader,
    user: state.auth.user,
    userStatus: state.auth.userStatus,
    isLoading: state.auth.isLoading,
    alertMessage: state.auth.alertMessage,
    showMessage: state.auth.showMessage
  };
};

export default connect(
  mapStateToProps,
  {
    userSignIn,
    hideMessage,
    showAuthLoader,
    userFacebookSignIn,
    userGoogleSignIn,
    userGithubSignIn,
    userTwitterSignIn,
    changeStatus
  }
)(SignIn);
